import { IDateRange } from "components/dashboard/product-template-table/utils/interfaces";
import { LagLeadLoadingConfig } from "../interfaces";

export enum XAxisType {
  TIME = "Time",
  VALUES = "Values",
}

export enum BoundType {
  MIN_MAX = "Min-Max",
  STD_DEV = "Standard Deviation",
  CONFIDENCE = "Confidence Interval",
}

export interface ConfidenceIntervalLineChartProps extends IDateRange {
  identifiers: string[];
  timeBoundIntervalInSeconds?: number;
  valueBoundsCount?: number;
  loadConf: LagLeadLoadingConfig;
  boundType: BoundType;
  xAxisType: XAxisType;
  hideHeader?: boolean;
  updateFrequency?: number;
  showDateSelection?: boolean;
  hideRefresh?: boolean;
}
